export const listMutations = <const>{
	PAKETOVY_MODUL_VOZIDLO_SELECT_MAPPER: 'PAKETOVY_MODUL_VOZIDLO_SELECT_MAPPER',
	PAKETOVY_MODUL_TYP_KOD_SELECT_MAPPER: 'paketovyModulTypKodSelectMapper',
	PAKETOVY_MODUL_LAK_DRUH_SELECT_MAPPER: 'PAKETOVY_MODUL_LAK_DRUH_SELECT_MAPPER',
	PAKETOVY_MODUL_ZAKAZNIK_SELECT_MAPPER: 'PAKETOVY_MODUL_ZAKAZNIK_SELECT_MAPPER',
	PAKETOVY_MODUL_PRACOVNIK_SELECT_MAPPER: 'PAKETOVY_MODUL_PRACOVNIK_SELECT_MAPPER',
	PAKETOVY_MODUL_NAKLADOVE_STREDISKO_SELECT_MAPPER: 'PAKETOVY_MODUL_NAKLADOVE_STREDISKO_SELECT_MAPPER',
	PAKETOVY_MODUL_GET_FAKTURACNI_PROFIL_DROPDOWN: 'PAKETOVY_MODUL_GET_FAKTURACNI_PROFIL_DROPDOWN',
	PAKETOVY_MODUL_SET_MULTIPLE_SELECTION: 'PAKETOVY_MODUL_SET_MULTIPLE_SELECTION',
	PAKETOVY_MODUL_INIT_FAKTURACNI_PROFIL_ID: 'PAKETOVY_MODUL_INIT_FAKTURACNI_PROFIL_ID',
	PAKETOVY_MODUL_CHECK_STREDNAKL: 'PAKETOVY_MODUL_CHECK_STREDNAKL',
};

export const listActions = <const>{
	FILTER_INIT: 'filterInit',
};
